import {
  IHealthPlanMappingItem,
  IHealthPlanMappingList,
} from '../Infrastructure/Interfaces';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const healthPlanPageNumber: any = {
  pageNumber: 0,
};

const HealthPlanPageNumberItemSlice = createSlice({
  name: 'healthplanpagenumber',
  initialState: { value: healthPlanPageNumber },
  reducers: {
    setHealthPlanPageNumber: (state, action) => {
      state.value = action.payload;
    },
  },
});

const healthPlanMappingInitialState: IHealthPlanMappingList = {
  loading: true,
  healthPlanMappingList: [],
};

const ItemInitialState: IHealthPlanMappingItem = {
  healthPlanMappingId: 0,
  healthPlanMasterId: 0,
  payerAddressId: 0,
  payerName: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  phoneNo: '',
  faxNo: '',
  displayName: '',
  isActive: true,
  healthPlanTypeId: 0,
  healthPlanType: '',
  healthPlanName: '',
  region: '',
  createdBy: '',
  createdOn: '',
  modifiedBy: '',
  modifiedOn: '',
  scenarioId:0,
  scenarioName: '',
  deliverOption:'',
  faxToFaxNumber:'',
  healthPlanId:'',
};

const HealthPlanMappingItemSlice = createSlice({
  name: 'IncidentTrackerItem',
  initialState: { value: ItemInitialState },
  reducers: {
    setHealthPlanMappingItem: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const fetchHealthPlanMappingList = createAsyncThunk(
  'fetchHealthPlanmappingList',
  async () => {
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    //const token = globalFetchToken(tokenurl, "", "5053");
    return axios.get(tokenurl).then(res => {
      if (res.data.success) {
        return axios
          .get(baseurl + '/Payer/get_healthplan_list', {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              return response.data.result;
            }
          });
      }
    });
  }
);

const HealthPlanMappingListSlice = createSlice({
  name: 'healthplanmapping',
  initialState: healthPlanMappingInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchHealthPlanMappingList.fulfilled, (state, action) => {
      state.loading = false;
      state.healthPlanMappingList = action.payload;
    });
    builder.addCase(fetchHealthPlanMappingList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchHealthPlanMappingList.rejected, (state, action) => {
      state.loading = false;
      state.healthPlanMappingList = [];
    });
  },
});

export const HealthPlanMappingReducer = HealthPlanMappingListSlice.reducer;

export const { setHealthPlanMappingItem } = HealthPlanMappingItemSlice.actions;

export const HealthPlanMappingItemReducer = HealthPlanMappingItemSlice.reducer;

export const { setHealthPlanPageNumber } =  HealthPlanPageNumberItemSlice.actions;

export const HealthPlanPageNumberItemReducer =  HealthPlanPageNumberItemSlice.reducer;
